export const validation = {
  maxTitleChar: 100,
  maxParagraphChar: 2000
}
